import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import React from "react";

interface Option {
  value: string | number;
  label: string;
}

interface CustomProductSelectProps {
  id?: string;
  name: string;
  label?: string;
  value?: string | number;
  optionlist: Option[];
  fullWidth?: boolean;
  sx?: object;
  handleChangeFunction?: (event: SelectChangeEvent<string | number>) => void;
  onChange?: (event: SelectChangeEvent<string | number>) => void;
  small?: boolean;
  middle?: boolean;
  className?: string;
  readonly?: boolean;
  variant?: "outlined" | "filled" | "standard";
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  defaultValue?: string | number;
}

const CustomProductSelect = React.forwardRef<
  HTMLSelectElement,
  CustomProductSelectProps
>((props, ref) => {
  const {
    id,
    name,
    label,
    value,
    optionlist,
    fullWidth = true,
    sx,
    handleChangeFunction,
    onChange,
    small = false,
    middle = false,
    className,
    variant = "outlined",
    error,
    helperText,
    readonly = false,
    disabled = false,
  } = props;

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    handleChangeFunction?.(event);
    onChange?.(event);
  };

  const selectStyle = {
    "& .MuiSelect-select": {
      // padding: "8.5px 14px",
      padding: "12px 14px",
      backgroundColor: "#fff",
    },
    "& .MuiInputBase-readOnly": {
      backgroundColor: "#f5f5f5",
    },
    width: middle ? "160px" : small ? "100px" : "100%",
    maxWidth: middle ? "160px" : small ? "100px" : "400px",
    ...sx,
  };

  return (
    <Box>
      <FormControl
        fullWidth
        sx={{ marginTop: 0 }}
        error={error}
        variant={variant}
      >
        {label && <InputLabel id={`${id || name}-label`}>{label}</InputLabel>}
        <Select
          variant="outlined"
          id={id}
          inputRef={ref}
          name={name}
          value={value ?? ""}
          label={label}
          labelId={`${id || name}-label`}
          readOnly={readonly}
          disabled={disabled}
          onChange={handleChange}
          sx={selectStyle}
          className={className}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 250,
              },
            },
          }}
        >
          {optionlist.map((option, index) => (
            <MenuItem
              key={`${option.value}-${index}`}
              value={option.value}
              sx={{
                paddingLeft: option.label.includes("-----")
                  ? "30px"
                  : undefined,
              }}
            >
              {option.label.replace("-----", "")}
            </MenuItem>
          ))}
        </Select>
        {(error || helperText) && (
          <FormHelperText id={`${name}-helper-text`}>
            {error ? helperText || "This field is required" : helperText}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
});

export default CustomProductSelect;
